<template>
    <page>
        <template #title>{{$t('pages.dashboard.account.users.edit.title')}}</template>

        <template #content>
            <m-form-user type="edit"/>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import MFormUser from "@modules/forms/concrete/m-form-user";
    import breadcrumbs from "@mixins/helpers/_breadcrumbs";
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "dashboard-account-user-edit",
        mixins: [breadcrumbs, errorHandler, notifications],
        components: {Page, MFormUser},
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.account.users.edit.meta.title')
            }
        },
        async created() {
            try {
                await this.requestUser({id: this.$route.params.id});
            } catch (e) {
                this.error.handle(e)
            }
            let user = this.getUser(this.$route.params.id);
            this.$iBreadcrumbs.setParentText(`${user.firstName} ${user.lastName}`);
        },
        computed: {
            ...mapGetters({
                getUser: "users/read"
            })
        },
        methods: {
            ...mapActions({
                requestUser: 'users/read'
            }),
        }

    }
</script>

<style scoped>

</style>
